import { FileManagementModule } from './../../kyd/file-management/file-management.module';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { Router } from '@angular/router';
import { TransferService } from 'src/app/kyd/services/transfer.service';
import { FileManagementService } from 'src/app/kyd/services/file-management.service';
import { QuestionnaireService } from 'src/app/kyd/services/questionnaire.service';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-dc-table',
    templateUrl: './dc-table.component.html',
    styleUrls: ['./dc-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DcTableComponent implements OnInit, OnChanges {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('ProgressTemplate', { static: true }) ProgressTemplate: TemplateRef<any>;
  @ViewChild('leiLinkTemplate', { static: true }) leiLinkTemplate: TemplateRef<any>;
  @ViewChild('leiLinkWithRefTemplate', { static: true }) leiLinkWithRefTemplate: TemplateRef<any>;
  @ViewChild('accessTagsLinkTemplate', { static: true }) accessTagsLinkTemplate: TemplateRef<any>;
  @ViewChild('userTagsLinkTemplate', { static: true }) userTagsLinkTemplate: TemplateRef<any>;
  @ViewChild('issuerNameLinkTemplate', { static: true }) issuerNameLinkTemplate: TemplateRef<any>;
  @ViewChild('distributorNameLinkTemplate', { static: true }) distributorNameLinkTemplate: TemplateRef<any>;
  @ViewChild('connectionButtonTemplate', { static: true }) connectionButtonTemplate: TemplateRef<any>;
  @ViewChild('linkRequestButtonTemplate', { static: true }) linkRequestButtonTemplate: TemplateRef<any>;
  @ViewChild('viewConnectionButtonTemplate', { static: true }) viewConnectionButtonTemplate: TemplateRef<any>;
  @ViewChild('viewIssuerRequestsButtonTemplate', { static: true }) viewIssuerRequestsButtonTemplate: TemplateRef<any>;
  @ViewChild('distributorContactsButtonTemplate', { static: true }) distributorContactsButtonTemplate: TemplateRef<any>;
  @ViewChild('manageFilesButtonTemplate', { static: true }) manageFilesButtonTemplate: TemplateRef<any>;
  @ViewChild('issuerContactsButtonTemplate', { static: true }) issuerContactsButtonTemplate: TemplateRef<any>;
  @ViewChild('dateTemplate', { static: true }) dateTemplate: TemplateRef<any>;
  @ViewChild('dateTimeTemplate', { static: true }) dateTimeTemplate: TemplateRef<any>;
  @ViewChild('actionTemplate', { static: true }) actionTemplate: TemplateRef<any>;
  @ViewChild('statusTemplate', { static: true }) statusTemplate: TemplateRef<any>;
  @ViewChild('issuerStatusTemplate', { static: true }) issuerStatusTemplate: TemplateRef<any>;
  @ViewChild('distNameAndConnectionStatus', { static: true }) distNameAndConnectionStatus: TemplateRef<any>;
  @ViewChild('downloadTemplate', { static: true }) downloadTemplate: TemplateRef<any>;
  @ViewChild('productActionButtonTemplate', { static: true }) productActionButtonTemplate: TemplateRef<any>;
  @ViewChild('numberTemplate', { static: true }) numberTemplate: TemplateRef<any>;
  @ViewChild('titlecaseTemplate', { static: true }) titlecaseTemplate: TemplateRef<any>;
  @ViewChild('downloadDocTemplate', { static: true }) downloadDocTemplate: TemplateRef<any>;
  @ViewChild('downloadButtonTemplate', { static: true }) downloadButtonTemplate: TemplateRef<any>;

  @Input() rows: any;
  @Input() columns: any;
  @Input() messages: any;
  @Input() sort: any;
  @Input() limit: number;
  @Input() filterValue = '';
  @Input() showFooter: boolean;
  @Input() scrollV: true;
  @Input() loading: boolean | false;

  @Input() selectedRow: boolean | false;
  @Input() selected;

  @Input() columnMode: string;

  @Output() public activate = new EventEmitter<any>();
  @Output() public action = new EventEmitter<any>();
  @Output() public select = new EventEmitter<any>();
  @Output() public filterParam = new EventEmitter();

  ColumnMode = ColumnMode;
  temp;
  temp2;
  faEllipsisV = faEllipsisV;
  columnProps;
  SelectionType = SelectionType;
  loadingBtn = false;

  constructor(
    private router: Router,
    private transferService: TransferService,
    private fileManagementService: FileManagementService,
    private questionnaireService: QuestionnaireService
  ) {}
  ngOnInit() {
    this.updateCols();
    this.temp2 = this.rows;
    this.transferService.childInitCompleteSubject.next();
    this.selected = this.selected ? this.selected : [];
  }

  ngAfterViewInit() {
    //this.table.columnMode = ColumnMode.force;
    //  this.updateFilter();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.temp2 = this.rows;
    this.updateFilter();
  }

  updateCols(): void {
    this.columns = this.columns.map((col: any) => ({
      ...col,
      cellTemplate: this[col.cellTemplate] ?? col.cellTemplate,
    }));
    this.columnProps = this.columns.map((column) => column.prop);
    this.updateFilter();
  }

  getColour(progress) {
    if (progress === 0) {
      return 'empty-progress';
    } else if (progress < 50) {
      return 'partial-progress';
    } else if (progress < 100) {
      return 'almost-progress';
    } else {
      return 'done-progress';
    }
  }

  getStatusColour(status) {
    if (status.toLowerCase() === 'active' || status.toLowerCase() === 'yes') {
      return 'badge-success';
    }
    return 'badge-expired';
  }

  getIssuerStatusColour(status) {
    if (status == 'Completed') {
      return 'badge-success';
    }
    if (status === 'Issuer to Action') {
      return 'badge-warning';
    }
    return 'badge-expired';
  }

  onActivate(event) {
    this.activate.emit(event);
  }

  rowAction(row, type) {
    const all = {
      row: row,
      type: type,
    };
    this.action.emit(all);
  }

  updateFilter() {
    if (this.filterValue == undefined || this.filterValue == '' || typeof this.filterValue != 'string') {
      return;
    }
    const val = this.filterValue.toLowerCase();
    this.temp = this.temp2;
    // filter our data
    const temp = this.temp.filter((currentRow) => {
      this.columnProps = this.columnProps ? this.columnProps : undefined;
      if (this.columnProps !== undefined) {
        return this.columnProps
          .map((columnProp) => {
            // check for a match
            // if (currentRow[columnProp] == null) {
            //   return false;
            // } else
            if (currentRow[columnProp] && typeof currentRow[columnProp] === 'string') {
              return currentRow[columnProp].toLowerCase().includes(val) || !val;
            }
            // else if (currentRow[columnProp] && typeof currentRow[columnProp].join('') === 'string') {
            //   return currentRow[columnProp].join('').toLowerCase().includes(val) || !val;
            // }
            else {
              return false;
            }
          })
          .reduce((previous, current) => previous || current);
      }
    });

    // update the rows
    this.rows = temp;
  }

  getStarColour(status) {
    if (status == 'ACTIVE') {
      return 'pink';
    } else {
      return 'grey-outline';
    }
  }

  viewRequest(value) {
    console.log('ON CLICK', value);
    this.filterParam.emit(value);
    this.transferService.setData(value);
    this.transferService.setLabel('distributor name');
    this.transferService.isClicked = true;
    this.router.navigateByUrl('requests');
    // this.router.navigate(['requests', value]);
  }

  viewLinkedKydRequest(value) {
    console.log('ON CLICK', value);
    const row = this.rows.filter((x) => x.id === value)[0];
    this.filterParam.emit(row.distributorsName);
    this.transferService.setData(row.distributorsName);
    this.transferService.setLabel('distributor name');
    this.transferService.isClicked = true;
    this.router.navigateByUrl('requests');
  }

  viewConnection(value) {
    console.log('ON CLICK', value);
    this.filterParam.emit(value);
    this.transferService.setData(value);
    this.router.navigateByUrl('connections');
    this.transferService.isClicked = true;
    // this.router.navigate(['connections', value]);
  }

  manageFiles(value) {
    console.log('ON CLICK', value);
    this.transferService.setData(value);
    this.router.navigateByUrl(`files/${value}`);
    this.transferService.isClicked = true;
  }

  viewDistributorContacts(value) {
    console.log('ON CLICK', value);
    this.transferService.setData(value);
    this.router.navigateByUrl('contacts/distributors');
    this.transferService.isClicked = true;
  }

  viewIssuerContacts(value) {
    console.log('ON CLICK', value);
    this.transferService.setData(value);
    this.router.navigateByUrl('contacts/issuers');
    this.transferService.isClicked = true;
  }

  viewDistributor(value) {
    console.log('ON CLICK', value);
    this.transferService.setData(value);
    this.router.navigateByUrl('distributors');
    this.transferService.isClicked = true;
  }

  viewIssuer(value) {
    console.log('ON CLICK', value);
    this.transferService.setData(value);
    this.router.navigateByUrl('issuers');
    this.transferService.isClicked = true;
  }

  viewIssuerRequests(value) {
    console.log('ON CLICK', value);
    this.transferService.setData(value);
    this.router.navigateByUrl('issuer-requests');
    this.transferService.isClicked = true;
  }

  download(value) {
    this.action.emit(value);
  }

  onSelect(e) {
    // console.log('Select Event', e.selected);
    this.select.emit(e.selected);
  }

  downloadFile(value, e) {
    console.log('ON CLICK', value);
    const id = e.target?.id;
    const element = document.getElementById(id);
    if (element) {
      element.classList.add('downloading');
      element.innerHTML = `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Downloading`;
    }
    this.fileManagementService.getRef(value).subscribe((ref) => {
      this.fileManagementService.getFile(value).then((file) => {
        const targetElement = document.getElementById(id);
        if (targetElement) {
          element.classList.remove('downloading');
          targetElement.innerHTML = '';
        }
        const blob = this.fileManagementService.convertBase64ToBlob(file.data);
        FileSaver.saveAs(blob, `${file.name}`);
      });
    });
  }

  async viewDDQ(row, e) {
    e.stopPropagation();
    window.open(`issuer-portal/ddq/${row.requestid}`);
  }
}
